export class Panel {
	constructor( node, opts ) {
		this.node = node;
		this.opts = {
			title: '.panels__title',
			toggle: '.panels__toggle',
			content: '.panels__content',
			openedClass: 'panels__panel--opened',
			...opts,
		};
		this.opened = this.node.classList.contains( this.opts.openedClass );
		this.title = this.node.querySelector( this.opts.title );
		this.toggle = this.node.querySelector( this.opts.toggle );
		this.content = this.node.querySelector( this.opts.content );

		if ( this.toggle ) {
			this.toggle.addEventListener( 'click', () => this.togglePanel() );
		}
	}

	open() {
		this.node.classList.add( this.opts.openedClass );
		this.toggle.setAttribute( 'aria-expanded', 'true' );

		this.content.style.display = 'block';

		let height = this.content.offsetHeight;

		this.content.style.height = '0px';
		this.content.style.overflow = 'hidden';

		this.content.style.transitionProperty = 'height, opacity';
		this.content.style.transitionDuration = '300ms';
		this.content.style.transitionTimingFunction = 'cubic-bezier(0.45, 0, 0.55, 1), linear';

		let transitionend = ( e ) => {
			this.content.removeAttribute( 'style' );
			this.opened = true;
			this.content.removeEventListener( 'transitionend', transitionend );
		};

		this.content.addEventListener( 'transitionend', transitionend );

		requestAnimationFrame( () => {
			requestAnimationFrame( () => {
				this.content.style.height = `${ height }px`;
				this.content.style.opacity = 1;
			} );
		} );
	}

	close() {
		this.node.classList.remove( this.opts.openedClass );
		this.toggle.setAttribute( 'aria-expanded', 'false' );
		this.content.style.display = 'block';
		this.content.style.overflow = 'hidden';
		this.content.style.height = `${ this.content.offsetHeight }px`;
		this.content.style.transitionProperty = 'height, opacity';
		this.content.style.transitionDuration = '300ms';
		this.content.style.transitionTimingFunction = 'cubic-bezier(0.45, 0, 0.55, 1), linear';

		let transitionend = ( e ) => {
			this.content.removeAttribute( 'style' );
			this.opened = false;
			this.content.removeEventListener( 'transitionend', transitionend );
		};

		this.content.addEventListener( 'transitionend', transitionend );

		requestAnimationFrame( () => {
			requestAnimationFrame( () => {
				this.content.style.height = '0';
				this.content.style.opacity = 0;
			} );
		} );
	}

	togglePanel() {
		return this.opened ? this.close() : this.open();
	}
}

export class Panels {
	constructor( node, opts ) {
		this.node = node;
		this.opts = {
			interactiveClass: 'panels--interactive',
			panels: '.panels__panel',
			...opts,
		};
		this.node.classList.add( this.opts.interactiveClass );
		this.panels = Array.from( this.node.querySelectorAll( this.opts.panels ) ).map( ( node ) => new Panel( node, this.opts ) );
	}
}

Panels.instances = Array.from( document.querySelectorAll( '.panels' ) ).map( ( node ) => new Panels( node ) );

// re initialize ajax loaded panels
document.body.addEventListener( 'wdg:fetch:refresh', () => {
	document.querySelectorAll( '.panels:not(.panels--interactive' ).forEach( ( node ) => {
		Panels.instances.push( new Panels( node ) );
	} );
} );
